import { createMediaQueryString } from "@faire/web/common/media";
import { DefaultTheme } from "@faire/web/slate/Theme";

const EXTRA_X_LARGE = 1660;

export const extendedMediaStrings = {
  xlarge: createMediaQueryString({
    min: `${DefaultTheme.viewport.minWidthBreakpoints.xlarge}px`,
    max: `${EXTRA_X_LARGE - 1}px`,
  }),
  xlargeAndBelow: createMediaQueryString({ max: `${EXTRA_X_LARGE - 1}px` }),
  xlargeAndAbove: DefaultTheme.media2strings.xlarge,
  extraxlarge: createMediaQueryString({ min: `${EXTRA_X_LARGE}px` }),
};

export const isExtraXLarge = (width: number) => width >= EXTRA_X_LARGE;
